import React,{useState,useEffect} from "react";
import '../css/homePage.css';
import '../css/footer.css';
import 'react-responsive-modal/styles.css';
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useNavigate } from "react-router-dom";
import EventList from '../services/register-service';
import HeaderComp from '../components/headerComponent';
import RegisterForm from '../components/registerComponent';
import FooterComponent from '../components/footeComponent';
import { Modal } from 'react-responsive-modal';
import { Document, Page, pdfjs,Text } from 'react-pdf';

function HomePage(){
    const navigate = useNavigate();
    const [eventData, setEventData] = useState([]);
    const [loading, setLoading] = useState(true);  
    const [toggleState, setToggleState] = useState(1); 
    const [modalFilename, setmodalFilename] = useState("");
    const [open, setOpen] = useState(false);
    const [micrositePath,setMicrositePath]= useState([]);
    let id =2;
    const fetchData = async () => {
        return await EventList.getEvents(id);
    }
    const [numPages, setNumPages] = useState(1);
    const [opens, setOpens] = useState(false);
    const dangerouslySetInnerHTML= "<p>hello dimpal</p>";
    const onOpenModals = () => {
        setOpens(true);
    };
    const onCloseModals = () => {
        setOpens(false);
  };
    // const defaultLayoutPluginInstance = defaultLayoutPlugin();
    let pdfpath = eventData?.agenda_url;
    pdfjs.GlobalWorkerOptions.workerSrc = 
  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    const onOpenModal = (filename) => {
        setmodalFilename(filename);
        setOpen(true);
    };
    const onCloseModal = () => {
        setOpen(false);
        setmodalFilename("");
    };
       
    const [pageNumber, setPageNumber] = useState(1);
  
    function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }
  
  function previousPage() {
    changePage(-1);
  }
  
  function nextPage() {
    changePage(1);
  }

    useEffect(() => {
        // onOpenModal(pdfpath);
        const fetchDataAndSetState = async () => {
            const result = await fetchData();
            // console.log('result',result);
            setMicrositePath(result?.microsite_path || null);
            setEventData(result || []);
        }
        fetchDataAndSetState();
        setLoading(false);
       
        // viewPDF(pdfpath, 'application/pdf');
        
    }, [toggleState]);
console.log('numPages',numPages);
    return(
        <>
    <div className="nw18-content-wrapper">
        <section className="nw18-top-section">
            <div className="nw18-max-width-class">
                <div className="nw18-content-inner-wrapper">
                   <HeaderComp eventData={eventData} openModal={onOpenModal} openReadModal={onOpenModals}/>
                    <RegisterForm micrositePath={micrositePath}/>
                    {/* {(
                       
                    )} */}
                      
                </div>            
            </div>
            
        </section>
        <Modal open={open} onClose={onCloseModal} center>
            <Document file={pdfpath} onLoadSuccess={onDocumentLoadSuccess}>
            <Page wrap={false} renderTextLayer={false} pageNumber={pageNumber} />
            
            </Document>
            <div className="nw18-pre-btn-div">
                <button
                  type="button"
                  disabled={pageNumber <= 1}
                  onClick={previousPage}
                  className="Pre nw18-pre-btn"
                >
              Previous
        </button>
        <button
          type="button"
          disabled={pageNumber >= numPages}
          onClick={nextPage}
           className="nw18-pre-btn"
        >
          Next
        </button>
        </div>
        </Modal>
        <Modal open={opens} onClose={onCloseModals}>
        {/* <Modal.Header onClose={onCloseModals}>Modal Header 1</Modal.Header> */}
        <div className="popup_content"> 
          <p>The Brand Blitz Quiz will be hosted online by QM Sai Ganesh, founder of India Wants To Know - India’s First Panel Quiz show, and former brand head of Dunzo.</p>

<p>This is India’s First Panel Business Quiz Show. In each round, the players and the QM will be joined by a celebrity panelist from the world of business and brands.</p>

<p>We have an incredible line-up of panelists joining us from the advertising, marketing, and media worlds. These industry experts will infuse the quiz with exciting stories, anecdotes, and conversations.</p>

<p>Don't miss out on this opportunity to showcase your brand knowledge and test your skills against fellow enthusiasts.</p>

<p>This quiz is open to corporates and college students from all over India.</p>
<p>Brand Blitz Quiz begins on August 20th, with the National Prelims which will be a software-based round. This will be followed by four Regional Finals and the National Finale, all live-streamed on CNBC’s YouTube Channel.</p>

<p>Register now and let's dive into the Brand Blitz-quiz frenzy!</p>
<p>Prizes worth 1.5 Lacs are up for grabs!</p>
<div className="nw18-date-details-div">
                         <ul className="nw18-digital-desc">
                            <li>National Finale Winner: Rs. 50,000</li>
                            <li>First Runner-Up: Rs. 30,000</li>
                            <li>Second Runner-Up: Rs. 10,000</li>
                            <li>All Regional Final Winners: Rs. 10,000 each</li>
                        </ul>
                         </div>
                         <p>*All prizes will be courtesy of Ajio e-vouchers.</p>
                         <p>Brand Blitz Quiz is brought to you by our title sponsor Cadbury’s Dairy Milk and Ajio as the lifestyle partner.</p>
        </div>
        </Modal>
        <FooterComponent/>
    </div>
    
   
        </>
    )
}
export default HomePage;
